import { CommonPublishCoupon } from '@bucketplace/common';
import { camelizeKeys } from 'humps';
import { stringify } from 'querystring';
import { fetcher } from '@/api/fetcher';
import { clientHttp } from '@/common/http';
import {
  RaffleEntryResponse,
  RepresentativeRaffleEvent,
  ResponseGetCouponMoldsPublish,
  SectionItemsResponse,
} from '@/promotions/types';

export const publishCartCouponMolds = async ({
  id,
}: {
  id: number;
}): Promise<ResponseGetCouponMoldsPublish> => {
  if (!id || isNaN(id) || id <= 0) {
    throw new Error('Invalid coupon id');
  }

  const res = await fetcher<ResponseGetCouponMoldsPublish>(
    `/api/promotions/coupon/${id}`,
  );
  return res;
};

export const publishProductCouponMolds = async ({
  id,
  userId,
}: {
  id: number;
  userId: string;
}): Promise<CommonPublishCoupon> => {
  const json = await clientHttp
    .post('/api/promotions/product-coupon/create', {
      json: {
        couponMoldId: id,
        userId,
      },
    })
    .json<CommonPublishCoupon>();
  return camelizeKeys(json) as CommonPublishCoupon;
};

export const getSectionItems = async (
  id: string,
  detailId: string,
  {
    sectionId,
    page,
    isLoggedIn,
  }: {
    sectionId?: string;
    page: number;
    isLoggedIn: boolean;
  },
): Promise<SectionItemsResponse> => {
  if (
    !id ||
    (typeof id === 'string' && (id.trim() === '' || isNaN(Number(id))))
  ) {
    throw new Error('Invalid promotion id');
  }

  const res = await fetcher<SectionItemsResponse>(
    `/api/promotions/${id}/section-items?${stringify({
      sectionId,
      detailId,
      page,
      isLoggedIn,
    })}`,
  );

  return res;
};

export const getExhibitionSectionItems = async (
  url: string,
): Promise<SectionItemsResponse['sectionItems']> => {
  const res = await fetcher<SectionItemsResponse>(url);

  return res.sectionItems;
};

export const getRaffleEvent = async (
  groupId: string,
): Promise<RepresentativeRaffleEvent> => {
  const res = await fetcher<RepresentativeRaffleEvent>(
    `/api/promotions/raffle/${groupId}`,
  );

  return res;
};

export const postRaffleEntry = async (
  eventId: string,
  exhibitionId: string,
): Promise<RaffleEntryResponse> => {
  const res = await clientHttp
    .post('/api/promotions/raffle/entry', {
      json: {
        eventId,
        campaignId: exhibitionId,
      },
    })
    .json<RaffleEntryResponse>();

  return res as RaffleEntryResponse;
};
